// Hostname-based feature flag for staging new content on the test domain only.
// Returns true when running on teststeadyeducation.com (or localhost in dev),
// false on the live steadyeducation.com production domain.
export function isTestSite() {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname || '';
  if (host === 'localhost' || host.startsWith('127.') || host.endsWith('.local')) return true;
  return host.startsWith('test') || host.includes('teststeadyeducation');
}

// Canonical URL helper — new SEO pages on test should still canonicalize to the live domain
// once they're promoted, so we use a single source of truth here.
export function canonicalUrl(path = '/') {
  return `https://steadyeducation.com${path.startsWith('/') ? path : '/' + path}`;
}
